<template>
  <div class="flex flex-col gap-1.5">
    <div class="flex justify-between items-center">
      <span class="text-xs text-nera-light-text-strong">Quota</span>
      <span class="text-xs text-nera-light-text-strong">{{ Math.round(percentage) }}%</span>
    </div>
    <div class="w-full h-1 bg-nera-border rounded-full overflow-hidden">
      <div class="h-full rounded-full transition-all duration-500"
        :style="{ width: `${percentage}%`, backgroundColor: barColor }" />
    </div>
    <p v-if="isDepletedSubCredits" class="text-xs text-red-400 leading-tight">
      Consuming from extra credits
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useAuthStore } from "../stores/auth";

const authStore = useAuthStore();

const percentage = computed(() => {
  const quota = authStore.user?.plan_quota;
  const sub = authStore.user?.sub_credits;
  if (!quota || quota === 0) return 0;
  return Math.min(Math.max((sub / quota) * 100, 0), 100);
});

const isDepletedSubCredits = computed(
  () => (authStore.user?.sub_credits ?? 0) <= 0,
);

const barColor = computed(() => {
  if (isDepletedSubCredits.value) return "#f87171";
  if (percentage.value <= 15) return "#f87171";
  if (percentage.value <= 35) return "#fb923c";
  return "#4ade80";
});
</script>
